module.exports = __webpack_public_path__ + "img/DW365-061.859db2a1.jpg";